import classNames from "classnames";
import { forwardRef } from "react";
import styles from "./Input.module.css";

export type Props = React.ComponentPropsWithoutRef<"input"> & {
  isInvalid?: boolean;
  forceUpper?: boolean;
  suffix?: string;
};

const Input = forwardRef<HTMLInputElement, Props>(({ isInvalid, forceUpper, ...props }, ref) => {
  const { type = "text", autoComplete = "off", spellCheck = "false" } = props;
  return (
    <div className={styles.container}>
      <input
        ref={ref}
        {...props}
        type={type}
        autoComplete={autoComplete}
        spellCheck={spellCheck}
        readOnly={props.disabled || props.readOnly}
        className={classNames(styles.input, props.className, {
          [styles.invalid]: isInvalid,
        })}
        onChange={(e) => {
          e.target.value = forceUpper ? e.target.value.toUpperCase() : e.target.value;
          return props.onChange?.(e);
        }}
      />
      {props.suffix && <span className={styles.suffix}>{props.suffix}</span>}
    </div>
  );
});

export default Input;
